import { useTranslation } from 'react-i18next';
import Button from '../../../../../../../../common/widgets/Button';
import Dialog from '../../../../../../../../common/widgets/Dialog';
import { CardFormFactor, FormFactorOptionType } from '../../../../../../enums';
import { resources } from '../../../../../../resources/resources';

interface CardDetailsDialogProps {
  onCloseDialog: () => void;
  onOrderClick: (event: any) => void;
  cardFormFactor: CardFormFactor[];
}

interface CardResources {
  className: string;
  title: string;
  info: string;
  id: number;
}

export const CardDetailsDialog = (props: CardDetailsDialogProps) => {
  const { onCloseDialog, onOrderClick, cardFormFactor } = props;
  const { t: translate } = useTranslation();
  const cardResources = getCardResources(cardFormFactor);
  return (
    <Dialog
      showCloseIcon
      closeOnClickOutside
      closeDialog={onCloseDialog}
      className="dialog-l"
    >
      <div className="dialog-content">
        <div className="ctd-list">
          {cardResources?.map(e => (
            <div key={e.id} className="cdt-item">
              <div className={e.className}>{translate(e.title)}</div>
              <div dangerouslySetInnerHTML={{ __html: translate(e.info) }} />
            </div>
          ))}
        </div>
      </div>
      <div className="dialog-actions vertical">
        <Button onClick={onOrderClick} className="btn btn-solid">
          {translate(resources.orderNow)}
        </Button>
      </div>
    </Dialog>
  );
};

const determineFormFactorType = (
  cardFormFactor: CardFormFactor[],
): FormFactorOptionType => {
  if (cardFormFactor.length >= 2) {
    return FormFactorOptionType.PlasticAndVirtual;
  }

  if (cardFormFactor.length === 0) {
    return FormFactorOptionType.OnlyPlastic;
  }

  return cardFormFactor[0] === CardFormFactor.Plastic
    ? FormFactorOptionType.OnlyPlastic
    : FormFactorOptionType.OnlyVirtual;
};

const getCardResources = (
  cardFormFactor: CardFormFactor[],
): CardResources[] => {
  const formFactorOptionType = determineFormFactorType(cardFormFactor);
  const baseResources = resources.employeeCards.buy.step1.details;

  switch (formFactorOptionType) {
    case FormFactorOptionType.OnlyPlastic:
      return [
        {
          title: baseResources.receiveTitle,
          info: baseResources.onlyPlastic.receiveInfo,
          className: 'cdt-title when',
          id: 1,
        },
        {
          title: baseResources.costTitle,
          info: baseResources.onlyPlastic.costInfo,
          className: 'cdt-title how-much',
          id: 2,
        },
      ];
    case FormFactorOptionType.OnlyVirtual:
      return [
        {
          title: baseResources.receiveTitle,
          info: baseResources.onlyVirtual.receiveInfo,
          className: 'cdt-title when',
          id: 1,
        },
        {
          title: baseResources.costTitle,
          info: baseResources.onlyVirtual.costInfo,
          className: 'cdt-title how-much',
          id: 2,
        },
      ];
    case FormFactorOptionType.PlasticAndVirtual:
      return [
        {
          title: baseResources.chooseVirtualTitle,
          info: baseResources.plasticAndVirtual.chooseVirtualInfo,
          className: 'cdt-title choose-virtual',
          id: 1,
        },
        {
          title: baseResources.receiveTitle,
          info: baseResources.plasticAndVirtual.receiveInfo,
          className: 'cdt-title when',
          id: 2,
        },
        {
          title: baseResources.costTitle,
          info: baseResources.plasticAndVirtual.costInfo,
          className: 'cdt-title how-much',
          id: 3,
        },
      ];
    default:
      return [];
  }
};
